import { render, staticRenderFns } from "./editTxt3Dialog.vue?vue&type=template&id=d66cc3c8&scoped=true"
import script from "./editTxt3Dialog.vue?vue&type=script&lang=js"
export * from "./editTxt3Dialog.vue?vue&type=script&lang=js"
import style0 from "./editTxt3Dialog.vue?vue&type=style&index=0&id=d66cc3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66cc3c8",
  null
  
)

export default component.exports